import { render, staticRenderFns } from "./SidebarCartItemsInfo.vue?vue&type=template&id=024de35d&"
import script from "./SidebarCartItemsInfo.vue?vue&type=script&lang=js&"
export * from "./SidebarCartItemsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('024de35d')) {
      api.createRecord('024de35d', component.options)
    } else {
      api.reload('024de35d', component.options)
    }
    module.hot.accept("./SidebarCartItemsInfo.vue?vue&type=template&id=024de35d&", function () {
      api.rerender('024de35d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/SidebarCartItemsInfo.vue"
export default component.exports